import baseTheme from '../light';

export default {
  ...baseTheme,
  nav: {
    ...baseTheme.nav,
    button: {
      bg: '#15B6E5',
      text: 'white',
    },
    icon: {
      color: '#15B6E5',
    },
    logo: {
      src: '/whitelabel/lowes/lowes_logo_white.svg',
      height: '40px',
      marginRight: '10px',
      marginLeft: '10px',
    },
  },
  header: {
    backgroundImage: '/whitelabel/lowes/bg@2x.png',
  },
};
